export default __webpack_public_path__ + "static/media/cassandra.572251f1.svg";